module.exports = __webpack_public_path__ + "img/bule12.db9116fb.png";